import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import {
  AdminTenantDetail,
  AdminTenantsPageResponse,
  AdminTenantSearchCriteria,
  CreateTenantDto,
  CreateTenantResponse,
  CreateTrialTenantDto,
  CreateTrialTenantResponse,
  UpdateTenantStatusDto,
} from '../models/admin-tenant.interface';

@Injectable({ providedIn: 'root' })
export class AdminTenantAdaptor {
  private http = inject(HttpClient);
  private baseUrl = `${environment.apiUrl}/admin/tenants`;

  listTenants(criteria: AdminTenantSearchCriteria): Observable<AdminTenantsPageResponse> {
    const { page, limit, q, status } = criteria;
    let url = `${this.baseUrl}?page=${page}&limit=${limit}`;
    if (q) url += `&q=${encodeURIComponent(q)}`;
    if (status) url += `&status=${status}`;
    return this.http
      .get<AdminTenantsPageResponse>(url)
      .pipe(catchError(this.handleError<AdminTenantsPageResponse>('listTenants')));
  }

  createTenant(dto: CreateTenantDto): Observable<CreateTenantResponse> {
    return this.http
      .post<CreateTenantResponse>(this.baseUrl, dto)
      .pipe(catchError(this.handleError<CreateTenantResponse>('createTenant')));
  }

  // Only reachable while billing is on; the API answers 404 otherwise.
  createTrialTenant(dto: CreateTrialTenantDto): Observable<CreateTrialTenantResponse> {
    return this.http
      .post<CreateTrialTenantResponse>(`${this.baseUrl}/trial`, dto)
      .pipe(catchError(this.handleError<CreateTrialTenantResponse>('createTrialTenant')));
  }

  getTenant(tenantId: number): Observable<AdminTenantDetail> {
    return this.http
      .get<AdminTenantDetail>(`${this.baseUrl}/${tenantId}`)
      .pipe(catchError(this.handleError<AdminTenantDetail>('getTenant')));
  }

  updateTenantStatus(tenantId: number, dto: UpdateTenantStatusDto): Observable<AdminTenantDetail> {
    return this.http
      .patch<AdminTenantDetail>(`${this.baseUrl}/${tenantId}/status`, dto)
      .pipe(catchError(this.handleError<AdminTenantDetail>('updateTenantStatus')));
  }

  private handleError<T>(operation = 'operation') {
    return (error: HttpErrorResponse): Observable<T> => {
      console.error(`${operation} failed in AdminTenantAdaptor:`, error);
      throw error;
    };
  }
}
